import React from 'react';
import { Link } from 'react-router-dom';
import { Award } from 'lucide-react';
export function AdultReturning() {
  return <section className="py-24 bg-paper border-y border-subtle-gray" data-id="element-581">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-582">
        <div className="text-center mb-12" data-id="element-583">
          <div className="inline-flex items-center gap-2 bg-storm-red/10 text-storm-red px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide mb-4" data-id="element-584">
            <Award className="w-3.5 h-3.5" data-id="element-585" />
            Returning Students
          </div>
          <h2 className="text-4xl md:text-5xl text-ink mb-6" data-id="element-586">
            What If I Trained Before?
          </h2>
          <p className="text-lg text-gray-warm max-w-3xl mx-auto" data-id="element-587">
            Storm welcomes adults returning to Taekwondo after a break — and
            adults transferring from another school. Your previous training
            counts.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-588">
          <div className="bg-off-white border border-subtle-gray rounded-2xl p-8" data-id="element-589">
            <h3 className="text-2xl text-ink mb-3" data-id="element-590">Previous Belt Rankings</h3>
            <p className="text-gray-warm leading-relaxed" data-id="element-591">
              Storm{' '}
              <span className="font-bold text-ink" data-id="element-592">
                honors previous Taekwondo belt rankings when appropriate
              </span>
              . Talk to a Storm coach about your background — your school, your
              last belt, when you last trained — and we'll figure out the right
              place to plug you back in.
            </p>
          </div>
          <div className="bg-off-white border border-subtle-gray rounded-2xl p-8" data-id="element-593">
            <h3 className="text-2xl text-ink mb-3" data-id="element-594">
              Coming Back After Time Off
            </h3>
            <p className="text-gray-warm leading-relaxed" data-id="element-595">
              It's very normal to feel rusty after years away. Storm coaches
              will ease you back in, scale the drills, and give you a clear path
              forward — whether that means refreshing fundamentals or jumping
              back into sparring at your previous level.
            </p>
          </div>
        </div>

        <div className="text-center mt-10" data-id="element-596">
          <Link to="/SignMeUp" className="btn-primary" data-id="element-597">
            Talk to a Storm Coach
          </Link>
        </div>
      </div>
    </section>;
}